import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";

import styles from './HistoryOrderItem.module.scss';
import more from '../../constants/images/more.svg';
import DetailedOptionsHistoryItem from "./DetailedOptionsHistoryItem/DetailedOptionsHistoryItem";
import {MAIN_ROUTES} from "../../routing/main_routes";

const HistoryOrderItem = ({order}) => {
    const [isDetailedOptionsVisible, setIsDetailedOptionsVisible] = useState(false);

    const navigate = useNavigate();

    const {offer, finished_on, to_client_feedback, to_cleaner_feedback} = order || {};
    const {application, cleaner_request} = offer || {};
    const {service_package, created_by_user: customer} = cleaner_request || {};

    const handleOpenDetailedOptions = (event) => {
        event.stopPropagation();

        setIsDetailedOptionsVisible(prev => !prev);
    }

    return (
        <div
            onClick={() => navigate(`${MAIN_ROUTES.COMPLETED_ORDERS}/${offer?.order}`)}
            className={styles.historyOrderItem}
        >
            <div className={styles.historyOrderItem_titleContainer}>
                <h3 className={styles.historyOrderItem_titleContainer_title}>{service_package?.name}</h3>

                <button
                    onClick={handleOpenDetailedOptions}
                    className={styles.historyOrderItem_titleContainer_button}
                >
                    <img src={more} alt="detailed info icon"/>
                </button>

                {isDetailedOptionsVisible &&
                    <DetailedOptionsHistoryItem id={offer?.order}/>}
            </div>

            <div className={styles.historyOrderItem_blocks}>
                <div className={styles.historyOrderItem_blocks_item}>
                    <p>Клієнт: {customer?.first_name}</p>
                    <p>Завершено {new Date(finished_on).toLocaleDateString()}</p>
                </div>

                <div className={styles.historyOrderItem_blocks_item}>
                    <p>Оплата: ₴{application?.application_price} </p>
                    <p>Оцінка {to_client_feedback?.client_assessment}/5</p>
                </div>
            </div>
        </div>
    );
};

export default HistoryOrderItem;
